import React, { useEffect, useState } from "react";

export default function Alumini() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        style={{
          position: "relative",
          top: windowWidth > 768 ? "125px" : "0px",
          marginBottom: "10vh",
          marginTop: "10vh",
          padding: windowWidth > 768 ? "80px" : "20px",
          height: "fit-content",
          textAlign: "center",
        }}
      >
        <p>
          JSS University is a young and dynamic Univerity which has started
          functioning in the year 2024-25
        </p>
      </div>
    </>
  );
}
